export default "__VITE_ASSET__CosyEOWb__"